import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import * as actTableManagement from 'actions/tableManagement'
import styles from './style.css'
import * as mpTableManagement from 'mixpanel/tableManagement'

import icTableMap from 'assets/images/ic_tablemap.png'
import icDuplicate from 'assets/images/ic_duplicate.png'

class FilteredGroup extends React.Component {
  render () {
    const {group, groupDetail} = this.props
    let activeStyle = styles['text-inactive']
    if (group.active) {
      activeStyle = styles['text-active']
    }
    const isRowSelected = groupDetail && group.id === groupDetail.id
    return (
      <tr className={`${isRowSelected ? styles.selected : ''} ${styles.row}`}
        onClick={this._onClickRow}
        onMouseEnter={this._onMouseEnter}
        onMouseLeave={this._onMouseLeave}
      >
        <td className={styles.name}>{group.name}</td>
        <td className={`${styles.name} ${activeStyle}`}>{group.active ? 'Active' : 'Inactive'}</td>
        <td className={styles.count}>{group.numberOfTables}</td>
        <td className={`${styles['action']} ${isRowSelected ? styles.active : ''}`}>
          <img width='32' height='32' src={icDuplicate} onClick={this._onDuplicateGroup} title='Duplicate' />
          <span className={styles.spacer} />
          <img width='32' height='32' src={icTableMap} onClick={this._onTableMap} title='Table Map' />
        </td>
      </tr>
    )
  }

  _onClickRow = () => {
    const {onClickRow, group} = this.props
    onClickRow(group)
  }

  _onTableMap = (e) => {
    const {dispatch, group} = this.props
    e.stopPropagation()
    e.preventDefault()
    mpTableManagement.tableGroupEnterMapLayout()
    dispatch(actTableManagement.setGroupDetail(group))
    browserHistory.push('/table-management/map')
  }

  _onDuplicateGroup = (e) => {
    const {onDuplicateGroup, group} = this.props
    e.stopPropagation()
    e.preventDefault()
    onDuplicateGroup(group)
  }
}

function mapStateToProps (state) {
  const {openRightColumn} = state.tableManagement.group
  return {
    openRightColumn
  }
}

export default connect(mapStateToProps)(FilteredGroup)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementGroup/List/FilteredGroup.js